import { DownOutlined } from '@ant-design/icons';
import { FC, useEffect, useState } from 'react';
import Confetti from 'react-confetti';
import classes from './Intro.module.scss';

const frameLength = 16;
const preloadImages = () => {
  for (let i = 1; i < frameLength; i++) {
    const img = new Image();
    img.src = `${process.env.PUBLIC_URL}/movie/${i}.jpg`;
  }
};
preloadImages();

const getHeight = (innerWidth: number) => {
  const imageHeight = innerWidth * 1.5;
  const bottom = imageHeight / 2;
  const scrollOffset = 70;
  return imageHeight + (frameLength - 1) * scrollOffset - bottom;
};

const Intro: FC = () => {
  const [confetti, setConfetti] = useState(true);
  const [railRef, setRailRef] = useState<HTMLDivElement | null>(null);
  const [canvasRef, setCanvasRef] = useState<HTMLCanvasElement | null>(null);
  const [frame, setFrame] = useState(1);

  useEffect(() => {
    if (canvasRef) {
      const ctx = canvasRef.getContext('2d');
      if (ctx) {
        const img = new Image();
        img.src = `${process.env.PUBLIC_URL}/movie/${frame}.jpg`;
        img.onload = () => {
          ctx.drawImage(img, 0, 0);
        };
      }
    }
  }, [canvasRef, frame]);

  useEffect(() => {
    if (railRef) {
      const railHeight = getHeight(railRef.offsetWidth);
      railRef.style.height = `${railHeight}px`;
      const scrollHandler = () => {
        const scrollTop = document.documentElement.scrollTop;
        const maxScrollTop = railHeight - window.innerHeight;
        const scrollFraction = scrollTop / maxScrollTop;
        const newFrame = Math.min(
          frameLength - 1,
          Math.ceil(scrollFraction * frameLength)
        );
        setFrame(newFrame > 0 ? newFrame : 1);

        if (scrollTop > maxScrollTop && confetti) {
          setConfetti(false);
        } else if (scrollTop === 0 && !confetti) {
          setConfetti(true);
        }
      };

      window.addEventListener('scroll', scrollHandler);
      return () => {
        window.removeEventListener('scroll', scrollHandler);
      };
    }
  }, [confetti, railRef]);

  return (
    <>
      <Confetti
        width={window.innerWidth}
        height={window.innerHeight}
        opacity={0.7}
        gravity={0.05}
        numberOfPieces={confetti ? 100 : 0}
        style={{ position: 'fixed', top: 0, left: 0, zIndex: 5 }}
        colors={['#db5443', '#f5bc1a']}
      />
      <div
        className={classes.IntroMovieRail}
        ref={setRailRef}
        style={{
          backgroundImage: `url("${process.env.PUBLIC_URL}/movie/bg.jpg")`,
        }}
      >
        <div className={classes.IntroMovieCanvas}>
          <canvas ref={setCanvasRef} width={720} height={1080} />
        </div>
        <div className={classes.scrollDown}>
          <p>아래로 내려주세요</p>
          <DownOutlined />
        </div>
      </div>
    </>
  );
};

export default Intro;
